
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaCross, FaTrash } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ToggleButton } from 'primereact/togglebutton';
import { func } from 'prop-types';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const Clientassign = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        selectedclient: '',
        selecteduser:'',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [usercomp,setUsercomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [newobjdata, setNewobj] = useState({});
    const [isclientmerge, setclientmerge] = useState(false);
     
    useEffect(()=>{
        getallclient();
        getuserslistsasper();
        getuserassign();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
        }catch(e){
            console.log(e);
        }
        
    };

    const reject = () => {
    //    toast.current.show({ severity: 'warn', summary: 'Client merger', detail: 'Canceled', life: 3000 });
    }

    const validateForm = (formData) => {
        let valid = true;
        const newErrors = {};
        if (formData.selectedclient == '' || formData.selectedclient == undefined) {
          valid = false;
          newErrors.selectedclient = 'Field is required';
        }

        if (formData.selecteduser == '' || formData.selecteduser == undefined) {
            valid = false;
            newErrors.selecteduser = 'Field is required';
        }
        setErrors(newErrors);
       return valid; 
    }

    function deleteassign(value){

        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: () => {
                let obj =  {'data': value};
                // obj = JSON.stringify(obj);
                console.log(obj);
                timesheetreportService.deleteassign(obj).then((response)=>{
                 if(response.status == 200){
                    toast.current.show({severity:'success', summary: "Client assign", detail:`Delete assigned`, life: 3000});
                    getuserassign();     
                 }else{
                    toast.current.show({severity:'error', summary: "Client assign", detail:`Not deleted`, life: 3000}); 
                 }  
                }).catch((error)=>{
                    toast.current.show({severity:'error', summary: "Client assign", detail:`Error`, life: 3000});
                }); 
            },
           //  accept,
            reject
        });
        // console.log("delete assign");              
    }
    function clientdisplay(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            // console.log(value.name);
            let checked = false;
            if(value.allowed == 'allowed'){
                checked = true; 
            }else{
                checked = false; 
            }

            emparr.push(<tr>
                 <td>{index + 1}</td>
                 <td>{value.clientname}</td>
                 <td>{value.name}</td>
                 <td>{value.project}</td>
                
                 <td><button type='button' className='btn btn-danger' onClick={() => deleteassign(value)}><FaTrash/></button></td>
            </tr>);
        }); 

        return emparr;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm(formData)){
            return; 
        }
        // console.log(formData);
        let obj = JSON.stringify(formData);
        timesheetuserService.adduserassign({formdata:obj}).then((response)=>{
           if(response.status == 200){
            toast.current.show({severity:'success', summary: "Client assign", detail:`Successfully assigned`, life: 3000});     
            getuserassign();  
           }else{
            toast.current.show({severity:'error', summary: "Client assign", detail:`Not assigned`, life: 3000});      
           }  
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Client assign", detail:`Error`, life: 3000});      
        });
    };

    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    function getuserslistsasper(){
       let emparr = [];
       timesheetService.getuserslistsasper().then((response)=>{
          if(response.status == 200){
            //   console.log(response);
             response.data.data.forEach((value,index)=>{
                if(value.name != ''){
                    emparr.push(<option value={value.id}>{value.name}</option>);
                }
             });
            setUsercomp(emparr)
          }else{
              
          }
       }).catch((error)=>{
          console.log(error); 
       });
    }

    function getuserassign(){
        setloading(false);
        timesheetService.getuserassign().then((response)=>{
           if(response.status == 200){
             setDatacomp(response.data.data);
             setDatacomptemp(response.data.data);
             setloading(true);
           }else{
            setDatacomp([]);  
            setDatacomptemp([]);
            setloading(true);
           }
        }).catch((error)=>{
           setloading(true);
           setDatacomp([]); 
           setDatacomptemp([]); 
        });
     }

     function searchqaclient(e,type=''){
            let value = e.target.value; 
         
            if(type == ''){
               
                let _clientlist = datacomptemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                //  console.log(value);
                // console.log('this section');
                // return; 
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.clientname?.toLowerCase()) || searchRegexSubclient.test(item?.clientname?.toLowerCase()) || searchRegexSubclient.test(item?.from_date?.toLowerCase()) || searchRegexSubclient.test(item?.to_date?.toLowerCase())
                  || searchRegexSubclient.test(item?.name?.toLowerCase())      
                )
                );
    
                if (foundItems.length > 0) {
                    setDatacomp(foundItems);
                } else {
                    setDatacomp(datacomptemp);
                }      
            }
    }

 return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog /> 
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
             {/* <Dialog header="" visible={isclientmerge} style={{ width: '60vw' }} onHide={() => setclientmerge(false)}>
                 <h4 className='error text-center'>Renaming please wait!</h4>
             </Dialog> */}
             
            
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className='col-md-12'>
                <div className='row'>
                     <div className='col-md-12'>
                    

                     
                     </div> 
                    
                   <div className="col-md-4">
                   <br/>
                        <label className='pull-left'>Client</label>
                        <br/>
                        <select className='custom-dropdown-style' name="selectedclient" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           <option value="all">All</option>
                           {clientcomp}
                        </select>
                        {errors.selectedclient && <span className='error'>{errors.selectedclient}</span>}
                    </div>

                    <div className="col-md-4">
                   <br/>
                        <label className='pull-left'>Select user</label>
                        <br/>
                        <select className='custom-dropdown-style' name="selecteduser" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select user</option>
                           <option value="all">All</option>
                           {usercomp}
                        </select>
                        {errors.selecteduser && <span className='error'>{errors.selecteduser}</span>}
                    </div>
                    
                    <div className="col-md-4 col-sm-4">
                        <div className='button-wrapper-style'>
                           {(formData.selecteduser == 'all' || formData.selectedclient == 'all')  ? (<></>) : (<Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' />) } 
                        </div>
                     </div>
                </div>
                <br/>
                <br/>
               
                </div>
               
                </div>
                </form>

                <div className='col-md-2'>
                    <input type="text" className='form-control' placeholder='Search' onKeyUp={(e) => searchqaclient(e,'')}/>
                </div>
                <div className='col-md-12'>
                    <br/>
                    {!isloaded ? loader.Loadermd() : datacomp.length > 0 ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col" style={{width:'100px'}}>User</th>
                                <th scope="col">Project</th>
                                <th scope="col">Action</th>  
                            </tr>
                        </thead>
                        <tbody>
                            {clientdisplay()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                   
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Clientassign;
